<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="emission-step">
    <h2 class="step-title">Dirección</h2>
    <p class="step-subtitle">Completa los datos de tu dirección</p>

    <div class="form-section">
      <div class="section-header">
        <el-icon class="section-icon"><Location /></el-icon>
        <span class="section-title">DIRECCIÓN</span>
      </div>

      <div class="form-grid">
        <div class="form-field">
          <label class="field-label">Calle <span class="required">*</span></label>
          <el-input v-model="formData.calle" placeholder="Ingresa la calle" class="field-input" />
        </div>

        <div class="form-field">
          <label class="field-label">Número Exterior <span class="required">*</span></label>
          <el-input v-model="formData.numeroExterior" placeholder="Ingresa el número" class="field-input" />
        </div>

        <div class="form-field">
          <label class="field-label">Número Interior</label>
          <el-input v-model="formData.numeroInterior" placeholder="S/N" class="field-input" />
        </div>

        <div class="form-field">
          <label class="field-label">Colonia <span class="required">*</span></label>
          <el-input v-model="formData.colonia" placeholder="Ingresa la colonia" class="field-input" readonly />
        </div>

        <div class="form-field">
          <label class="field-label">Municipio <span class="required">*</span></label>
          <el-input v-model="formData.municipio" placeholder="Ingresa el municipio" class="field-input" readonly />
        </div>

        <div class="form-field">
          <label class="field-label">Estado <span class="required">*</span></label>
          <el-input v-model="formData.estado" placeholder="Ingresa el estado" class="field-input" readonly />
        </div>

        <div class="form-field">
          <label class="field-label">Código Postal <span class="required">*</span></label>
          <el-input v-model="formData.cp" placeholder="Ingresa el código postal" class="field-input" />
        </div>
      </div>
    </div>

    <div class="step-actions">
      <el-button type="default" size="large" @click="emit('back')" class="back-button">
        ← Atrás
      </el-button>
      <el-button type="primary" size="large" :disabled="!canProceed" :loading="isLoading" @click.stop="emit('next')" class="next-button">
        Siguiente
      </el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Location } from '@element-plus/icons-vue';
import type { EmissionFormData } from '@/types/emission.types';

interface Props {
  formData: EmissionFormData;
  canProceed: boolean;
  isLoading: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
  back: [];
  next: [];
}>();
</script>

